import Author from "@/src/components/journal-site/common/article/article-authors-list/author/author";
import { Box, Typography } from "@mui/material";

interface AuthorsProps {
  authors?: Author[];
}

const ArticleAuthorsList = (props: AuthorsProps) => {
  const authors = props.authors?.slice(0, 6) || [];
  const hasMoreAuthors = props.authors && props.authors.length > 6;

  return (
    <Box
      sx={{
        fontSize: "inherit",
        color: "inherit",
        display: "inline",
      }}
    >
      {authors.map((person, index) => (
        <Box
          sx={{ display: "inherit", fontSize: "inherit", color: "inherit" }}
          key={index}
        >
          <Author author={person} key={index} />
          {index < authors.length - 1 && (
            <Typography component="span" sx={{ marginRight: ".25rem" }}>
              ,
            </Typography>
          )}
        </Box>
      ))}
      {hasMoreAuthors && (
        <Typography
          component="span"
          sx={{ ml: 0.2, fontSize: "inherit", color: "inherit" }}
        >
          ,et al.
        </Typography>
      )}
    </Box>
  );
};

export default ArticleAuthorsList;
